export const DASHBOARD_EXPORT_MAX_ROWS = 5000;

export type DashboardExportResult<T> = { rows: T[]; truncated: boolean };
